export enum TransferStatus {
    Ready,
    Queued,
    Preprocessing,
    Uploading,
    Downloading,
    Finished,
    Failed
}
